import { render, staticRenderFns } from "./PricesCardMobCon.vue?vue&type=template&id=ef7779b2&"
import script from "./PricesCardMobCon.vue?vue&type=script&lang=js&"
export * from "./PricesCardMobCon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports